import { useAppContext } from '../../../../Services/AppContext';
import FirstUpper from '../../../BaseModule/Components/FirstUpper';

export default function SearchWorkplaceNoResults() {
	const { translation } = useAppContext();

	return (
		<div className='search-user-wrapper__no-results'>
			<p className='search-user-wrapper__no-results__text'>
				<FirstUpper>
					{
						translation[
							'component.caseCreate.workplaceYouWereLookingForWasNotFoundInMEDDI'
						]
					}
				</FirstUpper>
			</p>
		</div>
	);
}
